import Swal from 'sweetalert2';

class SportBook {
    // Auto resize
    static autoResize() {
        window.addEventListener('message', function (event) {
            let json = $.parseJSON(event.data);

            if (json.swal) {
                Swal.fire(json.swal);

            } else {
                let height = json.resize.h;
                $('iframe').attr('height', `${height}px`);
            }
        });
    }
}

window.SportBook = SportBook;